import React from 'react';
import { motion } from 'framer-motion';

const skillCategories = [
  {
    title: "Mobile Development",
    skills: [
      "Kotlin",
      "Java",
      "Kotlin Multiplatform",
      "Compose Multiplatform",
      "Flutter/Dart",
      "SwiftUI",
      "Jetpack Compose",
      "Android SDK",
      "iOS SDK"
    ]
  },
  {
    title: "Web Development",
    skills: [
      "React",
      "Next.js",
      "TailwindCSS",
      "JavaScript",
      "TypeScript",
      "HTML",
      "CSS",
      "Responsive Design",
      "Web Performance Optimization"
    ]
  },
  {
    title: "APIs & SDKs",
    skills: [
      "REST",
      "Retrofit",
      "Ktor Client",
      "Firebase",
      "Google Maps",
      "Stripe",
      "Paystack",
      "Flutterwave",
      "Monnify",
      "JSON Parsing (Gson / Kotlinx Serialization)",
      "WebSockets",
      "Pagination",
      "API Error Handling"
    ]
  },
  {
    title: "Architecture & Testing",
    skills: [
      "MVVM",
      "MVI",
      "Clean Architecture",
      "Modularization",
      "Scalable Codebase Design",
      "TDD",
      "BDD",
      "JUnit",
      "Mockito",
      "Espresso",
      "Maestro",
      "Unit Testing",
      "UI Testing",
      "Integration Testing",
      "End-to-End Testing",
      "Test Automation"
    ]
  },
  {
    title: "Tools & DevOps",
    skills: [
      "Git",
      "GitHub Actions",
      "CI/CD",
      "Gradle",
      "App Signing & Release",
      "Play Store Deployment",
      "App Store Deployment",
      "Jira",
      "Figma",
      "Slack",
      "Notion",
      "Android Studio",
      "Xcode",
      "VS Code"
    ]
  },
  {
    title: "Concurrency, DI & Core",
    skills: [
      "Kotlin Coroutines",
      "Flow",
      "StateFlow",
      "SharedFlow",
      "LiveData",
      "Hilt",
      "Dagger",
      "Koin",
      "WorkManager",
      "Room",
      "DataStore",
      "State Management (ViewModel)"
    ]
  },
  {
    title: "Security & Authentication",
    skills: [
      "OAuth",
      "JWT",
      "Biometric Authentication",
      "Secure Storage",
      "App Security Best Practices"
    ]
  },
  {
    title: "Performance & Optimization",
    skills: [
      "Baseline Profiles",
      "App Startup Optimization",
      "Memory Leak Detection",
      "ANR Debugging",
      "Profiling (CPU, Memory, Network)"
    ]
  }
];

const Skills = () => {
  return (
    <section id='skills' className='py-24 bg-[#040811] relative border-t border-slate-800/50'>
      <div className='max-w-7xl mx-auto px-6 lg:px-8 relative z-10'>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className='text-3xl md:text-5xl font-bold text-white mb-4'>Skills & Technologies</h2>
          <div className="h-1 w-20 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skillCategories.map((category, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="bg-slate-800/30 border border-slate-700/50 p-6 rounded-2xl hover:border-secondary/50 transition-colors backdrop-blur-sm group"
            >
              <h3 className="text-xl font-bold text-white mb-6 group-hover:text-secondary transition-colors">
                {category.title}
              </h3>
              <div className="flex flex-wrap gap-3">
                {category.skills.map((skill, sIdx) => (
                  <span
                    key={sIdx}
                    className="px-4 py-2 bg-[#040811] text-slate-300 text-sm font-medium rounded-full border border-slate-700 hover:border-primary hover:text-white transition-all cursor-default shadow-sm"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Skills;
